export default "__VITE_ASSET__D6kzXMmk__"